import React from 'react';
import { useNavigate } from 'react-router-dom';
import { welcome, images } from '../data/village-data';
import ShareVillageCard from './ShareVillageCard';
import TestimonialWall from './TestimonialWall';
import GiftPromoCard from './GiftPromoCard';

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <section
      data-testid="welcome-page"
      className="welcome-page"
      style={{
        backgroundImage: `linear-gradient(rgba(15,10,25,0.6), rgba(15,10,25,0.7)), url(${images.treeOfLife})`,
      }}
    >
      <div className="welcome-content">
        <h1 data-testid="welcome-heading" className="welcome-heading">
          {welcome.heading}
        </h1>

        <p className="welcome-ending">{welcome.endingLine}</p>

        <button
          data-testid="cross-bridge-btn"
          className="village-btn village-btn--primary"
          onClick={() => navigate('/quiz')}
        >
          {welcome.cta}
        </button>
        <button
          data-testid="skip-to-village-btn"
          className="village-btn village-btn--secondary"
          onClick={() => navigate('/life-map')}
        >
          Explore the Village
        </button>

        <ShareVillageCard />

        <TestimonialWall />
      </div>
    </section>
  );
}
